// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QaKed","callInfo":"styles_callInfo__9Exfd"};